/**
 * SearchInputContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled search input container.
 */
const SearchInputContainer = styled.div<React.CSSProperties>`
  display: flex;
  height: ${32 * Screen.widthRatio}px;
  justify-content: start;
  left: ${310 * Screen.widthRatio}px;
  position: absolute;
  top: ${2 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(SearchInputContainer);
